/* ================================================== */
/*  MENU
/* ================================================== */

$(document).ready(function(){

	// --- HAMBURGER --- //
	$('.hamburger').on('click keypress', function(e){
		if (e.type == 'click' || e.keyCode == 13 || e.keyCode == 32) {
			$('body').toggleClass('menu--open');
			$(this).toggleClass('hamburger--open');
		}
		
		// var menuItem = $('.nav--menu .nav__li');
		// var menuItemActive = $('.nav--menu .nav__li');
		// if (menuItemActive.hasClass('hasNotDescendants')) {
		// 	menuItem.addClass('active');
		// }
	});
	
	// --- DROPDOWN MENU --- //
	$('.header__nav .dropdown-toggle').on('click keypress', function(e){
		e.preventDefault();
		if (e.type == 'click' || e.keyCode == 13 || e.keyCode == 32) {

			var menuItem = $('.nav--menu .nav__li');
			
			menuItem.removeClass('active').find('a').removeClass('active');
			$(this).addClass('active');
		}
	});
	
	// --- DROPDOWN MENU LANG --- //
	$('.nav--languages .dropdown-toggle').on('click keypress', function(e){
		e.preventDefault();
		if (e.type == 'click' || e.keyCode == 13 || e.keyCode == 32) {

			$('body').toggleClass('menuLang--open');
			
		}
	});

	// --- CLEAR TIMEOUT MENU --- //
	var removeDelayMenu;

	$('.header__nav')
	.on('mouseenter', function() {
		clearTimeout(removeDelayMenu);
	})
	.on('mouseleave', function() {
		removeDelayMenu = setTimeout(closeHeaderNav, 4000);
	});

	function closeHeaderNav() {
		$('body').removeClass('menu--open');
		$('.hamburger').removeClass('hamburger--open');
	}


	// --- CLEAR TIMEOUT MENU LANG --- //
	var removeDelayLang;

	$('.header__menu--right .langs, .header__menu--right .dropdown-menu')
	.on('mouseenter', function() {
		clearTimeout(removeDelayLang);
	})
	.on('mouseleave', function() {
		removeDelayLang = setTimeout(closeMenuLangs, 4000);
	});

	function closeMenuLangs() {
		$('body').removeClass('menuLang--open');
	}


});


